var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaysGrayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5862 3H3.4104C1.52689 3 0 4.52689 0 6.4104C0 8.29391 1.52689 9.82083 3.4104 9.82083H26.5862C28.4696 9.82083 29.9966 8.29391 29.9966 6.4104C29.9966 4.52689 28.4696 3 26.5862 3Z",
    fill: "#FBFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5862 11.5228H3.4104C1.52689 11.5228 0 13.0495 0 14.9332C0 16.8166 1.52689 18.3436 3.4104 18.3436H26.5862C28.4696 18.3436 29.9966 16.8166 29.9966 14.9332C29.9966 13.0495 28.4696 11.5228 26.5862 11.5228Z",
    fill: "#FBFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0679 20.0417H3.4104C1.52689 20.0417 0 21.5685 0 23.4521C0 25.3355 1.52689 26.8626 3.4104 26.8626H16.0679C17.9513 26.8626 19.4784 25.3355 19.4784 23.4521C19.4784 21.5685 17.9513 20.0417 16.0679 20.0417Z",
    fill: "#FBFDFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5896 20.0417H24.628C22.7447 20.0417 21.2176 21.5685 21.2176 23.4521C21.2176 25.3355 22.7447 26.8626 24.628 26.8626H26.5896C28.4732 26.8626 30 25.3355 30 23.4521C30 21.5685 28.4732 20.0417 26.5896 20.0417Z",
    fill: "#FBFDFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaysGrayIcon);
export default __webpack_public_path__ + "static/media/stays-gray-icon.8d27f3884d26ccb44a638f85a24348be.svg";
export { ForwardRef as ReactComponent };